import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../auth/AuthContext";

const formatError = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || "").filter(Boolean).join(" ");
  return String(detail);
};

const AdminLogin = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-screen bg-[#1A1A1A] flex items-center justify-center px-5" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-sm">
        <img src="/logo.webp" alt="On Point Homes logo" className="h-20 w-auto invert mb-8" />
        <p className="eyebrow text-[#8C6A4F] mb-4">Admin</p>
        <h1 className="font-serif text-4xl text-[#F7F5F2] tracking-tight">Admin Login</h1>
        <div className="mt-10 flex flex-col gap-6">
          <label className="block">
            <span className="eyebrow text-[#A3A09B] block mb-1">Email</span>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-email-input"
              className="w-full bg-transparent border-0 border-b border-white/25 focus:border-[#8C6A4F] outline-none py-3 text-[#F7F5F2] rounded-none transition-colors duration-300"
            />
          </label>
          <label className="block">
            <span className="eyebrow text-[#A3A09B] block mb-1">Password</span>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-password-input"
              className="w-full bg-transparent border-0 border-b border-white/25 focus:border-[#8C6A4F] outline-none py-3 text-[#F7F5F2] rounded-none transition-colors duration-300"
            />
          </label>
          {error && <p className="text-sm text-red-400" data-testid="admin-login-error">{error}</p>}
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-btn"
            className="mt-2 bg-[#F7F5F2] text-[#1A1A1A] font-mono text-[0.7rem] tracking-[0.2em] uppercase font-bold px-8 py-4 btn-sweep hover:text-[#F7F5F2] transition-colors duration-300 disabled:opacity-50"
          >
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </div>
      </form>
    </main>
  );
};

export default AdminLogin;
